import { render, staticRenderFns } from "./DashboardSkillsItem.vue?vue&type=template&id=5f8d8cf0"
import script from "./DashboardSkillsItem.vue?vue&type=script&lang=ts"
export * from "./DashboardSkillsItem.vue?vue&type=script&lang=ts"
import style0 from "./DashboardSkillsItem.vue?vue&type=style&index=0&id=5f8d8cf0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports